
import { GlobalContext } from 'components/GlobalContext';
import { IDealerInitResult } from 'models/sql/IDealer';
import { useContext, useEffect, useRef, useState } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { Route, Routes, useNavigate } from 'react-router-dom';
import OpportunityService from 'services/OpportunityService';
import OpportunitiesDetail from './Detail';
import OpportunitiesLookup from './Lookup';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import './styles/Opportunities.scss';

const OpportunitiesIndex = () => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const navigate = useNavigate();
    const [showLookup, setShowLookup] = useState(false);
    const [baseData, setbaseData] = useState<IDealerInitResult>();

    useEffect(() => {
        globalContext.setSecondaryNav(<>
            <Navbar.Brand
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}><strong><FontAwesomeIcon icon={faChevronLeft as IconProp} />&nbsp;Opportunities</strong></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                </Nav>
            </Navbar.Collapse>
        </>);

        (async () => {
            globalContextRef.current.setLoading(true);
            const accessToken = await globalContext.getAccessTokenAsync();
            const result = await OpportunityService.GetInitAsync(accessToken);

            if (result) {
                setbaseData(result);
            }

            globalContextRef.current.setLoading(false);
        })();
    }, []);

    if (!baseData) {
        return (
            <>
            </>
        );
    }

    return (
        <>
            <div>
                <Routes>
                    <Route path={"/Detail/:id?"} element={<OpportunitiesDetail baseData={baseData} />} />
                    <Route path={"/:page"} element={<OpportunitiesLookup baseData={baseData} />} />
                    <Route path={"*"} element={<OpportunitiesLookup baseData={baseData} />} />
                </Routes>
            </div>
        </>
    );
}

export default OpportunitiesIndex;
